/**
* Created by lobin on 2019/11/5.
*/
<template>
	<el-card class="box-card print-pick-code">
		<div slot="header" class="clearfix">
			<span>取件码打印(40mm*30mm)</span>
			<el-button style="float: right; padding: 3px 0" type="text" @click="$emit('close')">收起</el-button>
		</div>
		<el-form ref="form" :model="form" label-width="72px">
			<el-form-item label="打印方式:">
				<el-radio-group v-model="form.type" size="small">
					<el-radio-button label="0">打印取件码</el-radio-button>
					<el-radio-button label="1">边录边打印</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="出纸方向:">
				<el-radio-group v-model="form.orientation">
					<el-radio :label="1">长边</el-radio>
					<el-radio :label="0">短边</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item prop="shelf" class="shelf-select" label="货架:" v-if="stype === 1">
				<el-select v-model="form.shelf" placeholder="请选择货架" filterable size="small">
					<el-option v-for="item in shelves" :key="item._id" :label="item.name" :value="item.nano">
						{{ item.name }}
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="打印机:">
				<el-select v-model="form.printer" placeholder="请选择打印机" size="small">
					<el-option :label="item.name" :value="item.name" v-for="item in printers" :key="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开始编号:" v-if="form.type === '0'">
				<el-input-number v-model="form.start" :min="1" :max="100000" label="开始编号" size="small" style="width: 100%"></el-input-number>
			</el-form-item>
			<el-form-item label="打印数量:" v-if="form.type === '0'">
				<el-input-number v-model="form.num"  :min="1" :max="1000000" label="打印数量" size="small" style="width: 100%"></el-input-number>
			</el-form-item>
			<el-button type="primary"  size="small" style="width: 100%" v-if="form.type === '0'" @click="print" :disabled="!canPrint">打印</el-button>
		</el-form>
	</el-card>
</template>

<script type="text/babel">
	import moment from 'moment';
	import {mapState} from "vuex";
	const templateURL = "https://most-sc.oss-cn-chengdu.aliyuncs.com/pickcode.json"
	export default {
		data(){
			return {
				form:{
					type:'0',
					orientation: 1,
					start: 0,
					num: 1,
					printer:'',
					shelf: ''
				},
				printers: [],
				socket: null,
			}
		},
		created(){
			const printer = window.localStorage.getItem('printer');
			if(printer) this.form.printer = printer;
			const printerUrl = process.env.VUE_APP_PRINTERURL;
			this.socket = new WebSocket(printerUrl);
			this.socket.onopen = () => {
				this.getPrinters();
			}
			this.socket.onerror = () => {
				this.$notify.error({
					title: '系统错误',
					duration: 0,
					dangerouslyUseHTMLString: true,
					message: `<div class="print_info">亲，打印取件码标签需要菜鸟打印组件启动失败，解决办法：
                                    <h3>1、未安装控件</h3>
                                    <p>请先安装控件，<a href="http://cloudprint.cainiao.com/cloudprint/client/CNPrintSetup.exe" target="_blank">请点击此处下载</a>。安装好后重启浏览器即可。</p>
                                    <h3>2、已安装控件</h3>
                                    <p>请在电脑的开始菜单-->“所有程序”里找到“CAINIAO打印组件”进行启动。</p></div>`,
				});
				this.printer.errMsg = '连接打印组件失败！';
			};
		},
		computed:{
			...mapState('site', {
				stype: state => state.info.stype,
				shelves: state => state.shelves,
			}),
			canPrint(){
				return this.form.printer && this.form.start && this.form.num;
			}
		},
		watch:{
			"form.printer"(){
				window.localStorage.setItem('printer', this.form.printer);
			},
			"form.type"(val){
				this.$emit('changePrintType', val)
			}
		},
		methods:{
			getPrinters(){
				var request  = {
					"cmd": "getPrinters",
					"requestID": "123458976",
					"version": "1.0"
				};
				this.socket.send(JSON.stringify(request));
				this.socket.onmessage = ({ data }) => {
					const printers = JSON.parse(data);
					if(printers.status === 'success'){
						this.printers = printers.printers;
					}
				}
			},
			getUUID(len = 8){
				let id;
				const UUID = [];
				do {
					id = Math.random().toString(16).slice(len * -1).toUpperCase();
				} while (UUID.includes(id));
				UUID.push(id);
				return id;
			},
			print(serial){
				this.setConfig();
				const docs = this.gendocuments(serial);
				const request = {
					"cmd": "print",
					"requestID": "123458976",
					"version": "1.0",
					"task": {
						"taskID": this.getUUID(),
						"preview": false,
						"printer": this.form.printer,
						"previewType": "pdf",
						"firstDocumentNumber": 10,
						"totalDocumentCount": 100,
						documents:docs,
					}
				}
				this.socket.send(JSON.stringify(request))
			},
			gendocuments(serial){
				let result = [];
				const curDate = moment().format("YYYY/MM/DD");
				const month = moment().format("MM");
				if(this.form.type === '1'){
					result = [
						{
							"documentID": "0123456789",
							"contents": [{
								"data": {
									curDate,
									month,
									serial: `${serial}`,
								},
								templateURL
							}]
						}
					]
				}else{
					let day = '';
					const num = this.form.num;
          const start = this.form.start;
          if(this.stype === 0){
						day = moment().format("DD");
					}else{
						day = this.form.shelf + '-' + moment().format("D");
					}
					const siteid = this.$store.state.baseInfo.userInfo.site;
					for(let i = 0; i < num; i++){
						result.push({
							"documentID": "0123456789",
							"contents": [{
								"data": {
									curDate,
									month,
									qrcode: `${process.env.VUE_APP_QRCODEURL}?id=${siteid}`,
									serial: `${day}-${start + i}`,
								},
								templateURL
							}]
						})
					}
				}
				return result;
			},
			setConfig(){
				this.socket.send(JSON.stringify({
						"cmd": "setPrinterConfig",
						"requestID": "123458976",
						"version": "1.0",
						"printer": {
							"name": this.form.printer,
							"autoPageSize": true,
							"orientation": this.form.orientation,
							"paperSize": {
								"width": 40,
								"height": 30
							}
						}
					}
				))
			}
		}
	}
</script>

<style lang="less" rel="stylesheet/less">
	.print-pick-code {
		width: 300px;
		position: fixed;
		right: 10px;
		top:50%;
		transform: translate(0, -50%);
	}
</style>
